import React, { FC } from 'react';

import { Button } from '@material-ui/core';

import { ReactComponent as GoogleIcon } from 'assets/icons/general/google.svg';
import LoaderButton from 'components/LoaderButton/LoaderButton';
import useGoogleAuth from 'services/common/useGoogleAuth/useGoogleAuth';
import { isGoogleLoginTestEnabled } from 'utils/googleLoginTestFlag/googleLoginTestFlag';

type Props = {
  label: string;
};

const GoogleLoginButton: FC<Props> = ({ label }) => {
  const { login, isLoading, isReady } = useGoogleAuth();

  if (!isGoogleLoginTestEnabled()) {
    return null;
  }

  return (
    <LoaderButton isLoading={isLoading}>
      <Button
        variant='contained'
        onClick={login}
        size='large'
        disabled={!isReady}
        startIcon={<GoogleIcon width={18} />}
      >
        {label}
      </Button>
    </LoaderButton>
  );
};

export default GoogleLoginButton;
